import { useCard } from '@orbital/games-frontend-library'
import React from 'react'
import { handleCardSuit } from '../../../components/card/helpers/useCardSuit'
import { colors } from '../../../lib/colors'
import { CardWrapper, PlaceHolder, CardFront } from './CardsStyled'

function Player({ cardList, winCombination }: any) {
  const { handleCardSymbol, handleCardColor } = useCard()
  return (
    <CardWrapper>
      {cardList.map((card: string, id: number) => (
        <PlaceHolder key={id}>
          <CardFront
            suitColor={handleCardColor(card, colors.cardRed, colors.cardBlack)}
            background={
              winCombination[id] === '1' ? colors.secondary : colors.cardWhite
            }
          >
            <p>{handleCardSymbol(card)}</p>
            {handleCardSuit(card)}
          </CardFront>
        </PlaceHolder>
      ))}
    </CardWrapper>
  )
}
export default Player
